module.exports = "/_next/static/images/huawei-icon-7b41f2e864f050e8380c3aa9edc14f3a.png";